import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteAnalyzerDish = (analyzerDishId: number) => {
  return axios.delete(`/api/dishes/connections/${analyzerDishId}`);
};

type UseDeleteAnalyzerDishOptions = {
  config?: MutationConfig<typeof deleteAnalyzerDish>;
};

export const useDeleteAnalyzerDish = ({
  config,
}: UseDeleteAnalyzerDishOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousAnalyzerDishes) {
        queryClient.setQueryData(
          ['analyzerDish'],
          context.previousAnalyzerDishes
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['analyzerDish']);
      queryClient.invalidateQueries(['dishes']);
      queryClient.invalidateQueries(['locations']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: deleteAnalyzerDish,
  });
};
